// extracted by mini-css-extract-plugin
export default {"dialog_buttons_group":"DialogButtonGroup_dialog_buttons_group__89JM9","horizontal":"DialogButtonGroup_horizontal__HXSZ0","vertical":"DialogButtonGroup_vertical__MWYPP"};